import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTitle } from '../../../context/TitleContext';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaArrowLeft, FaClock, FaCheck, FaTimes } from 'react-icons/fa';
import { showErrorToast } from '../../../shared/utils/toastHelper';
import apiClient from '../../../shared/utils/apiConfig';

const DoctorAppointments = () => {
    const { clinicId } = useParams();
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    
    const [workDays, setWorkDays] = useState([]);
    const [emptyDays, setEmptyDays] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTitle('المواعيد');
        fetchAppointments();
    }, [setTitle, clinicId]);

    const fetchAppointments = async () => {
        try {
            setLoading(true);
            
            const [workDaysResponse, emptyDaysResponse] = await Promise.all([
                apiClient.get(`/doctor_dash/doctor_work_days?clinic_id=${clinicId}`),
                apiClient.get(`/doctor_dash/empty_work_days?clinic_id=${clinicId}`)
            ]);

            setWorkDays(workDaysResponse.data?.data || workDaysResponse.data || []);
            setEmptyDays(emptyDaysResponse.data?.data || emptyDaysResponse.data || []);
        } catch (error) {
            showErrorToast('فشل في جلب المواعيد');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted">جاري تحميل المواعيد...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0">المواعيد</h4>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => navigate('/doctor/clinics')}
                    >
                        <FaArrowLeft className="mx-2" />
                        رجوع
                    </button>
                </div>

                {/* Work Days */}
                <div className="card shadow-sm mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">
                            <FaCheck className="mx-2" />
                            أيام العمل
                        </h5>
                    </div>
                    <div className="card-body">
                        {workDays.length === 0 ? (
                            <p className="text-muted text-center">لا توجد أيام عمل</p>
                        ) : (
                            <div className="row">
                                {workDays.map((day, index) => (
                                    <motion.div
                                        key={day.id || index}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                        className="col-md-4 mb-3"
                                    >
                                        <div className="card border-success">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <FaCalendarAlt className="text-success mx-2" />
                                                    <div>
                                                        <h6 className="mb-1">{day.day_name || day.date || 'يوم'}</h6>
                                                        <small className="text-muted">
                                                            {day.start_time} - {day.end_time}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Empty Days */}
                <div className="card shadow-sm">
                    <div className="card-header">
                        <h5 className="mb-0">
                            <FaTimes className="mx-2" />
                            الأيام الفارغة
                        </h5>
                    </div>
                    <div className="card-body">
                        {emptyDays.length === 0 ? (
                            <p className="text-muted text-center">لا توجد أيام فارغة</p>
                        ) : (
                            <div className="row">
                                {emptyDays.map((day, index) => (
                                    <motion.div
                                        key={day.id || index}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                        className="col-md-4 mb-3"
                                    >
                                        <div className="card border-danger">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <FaCalendarAlt className="text-danger mx-2" />
                                                    <div>
                                                        <h6 className="mb-1">{day.day_name || day.date || 'يوم'}</h6>
                                                        <small className="text-muted">لا توجد مواعيد</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoctorAppointments;

